import React, { useState } from 'react';
import { RocketIcon, MenuIcon, XIcon, LayoutDashboardIcon, SearchIcon, FileTextIcon, MegaphoneIcon, Image as ImageIcon, MailIcon, NetworkIcon, UsersIcon, SplitSquareHorizontalIcon, MicIcon, GlobeIcon, LogOutIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Dashboard } from '../components/app/Dashboard';
import { ProductAnalyzer } from '../components/app/ProductAnalyzer';
import { SalesLetterGenerator } from '../components/app/SalesLetterGenerator';
import { AdCopyEngine } from '../components/app/AdCopyEngine';
import { FlyerBuilder } from '../components/app/FlyerBuilder';
import { EmailFunnelSequence } from '../components/app/EmailFunnelSequence';
import { FunnelArchitect } from '../components/app/FunnelArchitect';
import { AvatarResearch } from '../components/app/AvatarResearch';
import { ABTestVariants } from '../components/app/ABTestVariants';
import { BrandVoiceCalibrator } from '../components/app/BrandVoiceCalibrator';
import { MultiLanguageOutput } from '../components/app/MultiLanguageOutput';
export function ComboLaunchApp() {
  const [activeView, setActiveView] = useState('dashboard');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigation = [{
    id: 'dashboard',
    name: 'Dashboard',
    icon: LayoutDashboardIcon
  }, {
    id: 'analyzer',
    name: 'Product Analyzer',
    icon: SearchIcon
  }, {
    id: 'sales-letter',
    name: 'Sales Letter Gen',
    icon: FileTextIcon
  }, {
    id: 'ads',
    name: 'Ad Copy Engine',
    icon: MegaphoneIcon
  }, {
    id: 'flyer',
    name: 'Flyer Builder',
    icon: ImageIcon
  }, {
    id: 'emails',
    name: 'Email Sequence',
    icon: MailIcon
  }, {
    id: 'funnel',
    name: 'Funnel Architect',
    icon: NetworkIcon
  }, {
    id: 'avatar',
    name: 'Avatar Research',
    icon: UsersIcon
  }, {
    id: 'ab-test',
    name: 'A/B Test Variants',
    icon: SplitSquareHorizontalIcon
  }, {
    id: 'brand-voice',
    name: 'Brand Voice',
    icon: MicIcon
  }, {
    id: 'multi-lang',
    name: 'Multi-Language',
    icon: GlobeIcon
  }];
  const renderView = () => {
    switch (activeView) {
      case 'dashboard':
        return <Dashboard onNavigate={setActiveView} data-id="element-825" />;
      case 'analyzer':
        return <ProductAnalyzer data-id="element-826" />;
      case 'sales-letter':
        return <SalesLetterGenerator data-id="element-827" />;
      case 'ads':
        return <AdCopyEngine data-id="element-828" />;
      case 'flyer':
        return <FlyerBuilder data-id="element-829" />;
      case 'emails':
        return <EmailFunnelSequence data-id="element-830" />;
      case 'funnel':
        return <FunnelArchitect data-id="element-831" />;
      case 'avatar':
        return <AvatarResearch data-id="element-832" />;
      case 'ab-test':
        return <ABTestVariants data-id="element-833" />;
      case 'brand-voice':
        return <BrandVoiceCalibrator data-id="element-834" />;
      case 'multi-lang':
        return <MultiLanguageOutput data-id="element-835" />;
      default:
        return <Dashboard onNavigate={setActiveView} data-id="element-836" />;
    }
  };
  return <div className="min-h-screen bg-slate-50 flex font-sans" data-id="element-837">
      {/* Mobile Sidebar Overlay */}
      {isMobileMenuOpen && <div className="fixed inset-0 bg-slate-900/50 z-40 lg:hidden" onClick={() => setIsMobileMenuOpen(false)} data-id="element-838" />}

      {/* Sidebar */}
      <aside className={`
        fixed inset-y-0 left-0 z-50 w-64 bg-slate-900 text-slate-300 transition-transform duration-300 ease-in-out
        lg:translate-x-0 lg:static lg:shrink-0 flex flex-col
        ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'}
      `} data-id="element-839">
        <div className="h-16 flex items-center px-6 border-b border-slate-800" data-id="element-840">
          <Link to="/app" className="flex items-center gap-2 text-white font-bold text-xl tracking-tight" data-id="element-841">
            <RocketIcon className="w-6 h-6 text-indigo-500" data-id="element-842" />
            ComboLaunch <span className="text-indigo-500" data-id="element-843">AI</span>
          </Link>
          <button className="ml-auto lg:hidden text-slate-400 hover:text-white" onClick={() => setIsMobileMenuOpen(false)} data-id="element-844">
            <XIcon className="w-5 h-5" data-id="element-845" />
          </button>
        </div>

        <div className="p-4 flex-1 overflow-y-auto space-y-1" data-id="element-846">
          <div className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-4 px-2 mt-4" data-id="element-847">
            Menú Principal
          </div>
          {navigation.map(item => <button key={item.id} onClick={() => {
          setActiveView(item.id);
          setIsMobileMenuOpen(false);
        }} className={`
                w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors
                ${activeView === item.id ? 'bg-indigo-600 text-white' : 'hover:bg-slate-800 hover:text-white'}
              `} data-id="element-848">
              <item.icon className={`w-5 h-5 ${activeView === item.id ? 'text-indigo-200' : 'text-slate-400'}`} data-id="element-849" />
              {item.name}
            </button>)}
        </div>

        <div className="p-4 border-t border-slate-800" data-id="element-850">
          <div className="flex items-center gap-3 px-2" data-id="element-851">
            <div className="w-8 h-8 rounded-full bg-indigo-500 flex items-center justify-center text-white font-bold text-sm" data-id="element-852">
              C
            </div>
            <div className="flex-1 min-w-0" data-id="element-853">
              <p className="text-sm font-medium text-white truncate" data-id="element-854">
                Creadora Pro
              </p>
              <p className="text-xs text-slate-500 truncate" data-id="element-855">Plan Creator</p>
            </div>
            <Link to="/app" className="text-slate-400 hover:text-white" data-id="element-856">
              <LogOutIcon className="w-4 h-4" data-id="element-857" />
            </Link>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 flex flex-col min-w-0 overflow-hidden" data-id="element-858">
        {/* Top Header */}
        <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-4 lg:px-8 shrink-0" data-id="element-859">
          <div className="flex items-center gap-4" data-id="element-860">
            <button className="lg:hidden text-slate-500 hover:text-slate-900" onClick={() => setIsMobileMenuOpen(true)} data-id="element-861">
              <MenuIcon className="w-6 h-6" data-id="element-862" />
            </button>
            <h2 className="text-lg font-semibold text-slate-800 hidden sm:block" data-id="element-863">
              {navigation.find(n => n.id === activeView)?.name}
            </h2>
          </div>
          <div className="flex items-center gap-4" data-id="element-864">
            <div className="hidden sm:flex items-center gap-2 text-sm" data-id="element-865">
              <span className="w-2 h-2 rounded-full bg-green-500" data-id="element-866"></span>
              <span className="text-slate-500" data-id="element-867">Sistema Operativo</span>
            </div>
            <button className="bg-indigo-50 text-indigo-600 px-3 py-1.5 rounded-md text-sm font-medium hover:bg-indigo-100 transition-colors" data-id="element-868">
              Upgrade
            </button>
          </div>
        </header>

        {/* View Content */}
        <div className="flex-1 overflow-y-auto p-4 lg:p-8" data-id="element-869">{renderView()}</div>
      </main>
    </div>;
}